<template>
  <v-layout wrap align-center>
    <v-autocomplete
      v-model="selectedAuto"
      :items="driverAvailableAutos"
      :loading="isAutoSearchLoading"
      :search-input.sync="searchAutoInput"
      :label="$t('common.fields.selectAuto')"
      :placeholder="$t('driverAutos.fields.selectAuto.placeholder')"
      item-text="title"
      item-value="id"
      autocomplete="off"
      class="mr-4"
      return-object
      hide-no-data
    ></v-autocomplete>
    <v-btn
      v-if="$can('driver_show_button_add_auto')"
      type="button"
      color="warning mt-3"
      :disabled="!selectedAuto || driverAutos.length > 19"
      :loading="isAutoLoading"
      large
      depressed
      @click="addAuto"
      >{{ $t('common.btns.addAuto') }}</v-btn
    >
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'DriverAddAuto',
  components: {},
  data() {
    return {
      selectedAuto: null,
      isAutoSearchLoading: false,
      isAutoLoading: false,
      searchAutoInput: '',
      timerId: null,
    };
  },
  computed: {
    ...mapGetters({
      driverAvailableAutos: 'driver/getDriverAvailableAutos',
      driverAutos: 'driver/getDriverAutos',
    }),
  },
  watch: {
    async searchAutoInput(val) {
      if (!val) {
        this.selectedAuto = null;
        this.setDriverAvailableAutos([]);
        return;
      }
      if (this.selectedAuto && this.selectedAuto.title === val) {
        return;
      }
      await this.getAvailableAutos(val);
    },
  },
  methods: {
    ...mapActions({
      fetchDriverAvailableAutos: 'driver/fetchDriverAvailableAutos',
      addDriverAuto: 'driver/addDriverAuto',
    }),
    ...mapMutations({
      setDriverAvailableAutos: 'driver/setDriverAvailableAutos',
      clearAlertError: 'global/clearAlertError',
    }),
    async getAvailableAutos(searchString) {
      /* eslint-disable */
      if (
        !searchString ||
        searchString.trim().length < 3 ||
        (this.selectedAuto && searchString.trim() === this.selectedAuto.title)
      ) {
        this.setDriverAvailableAutos([]);
        return;
      }
      /* eslint-enable */

      // cancel pending call
      clearTimeout(this.timerId);

      // delay new call 500ms
      this.timerId = setTimeout(async () => {
        // this.toggleSaveBtnDisabledState(true);
        this.isAutoSearchLoading = true;

        await this.fetchDriverAvailableAutos({
          id: this.$route.params.driverId,
          searchString,
        });
        this.isAutoSearchLoading = false;
      }, 500);
    },
    async addAuto() {
      this.isAutoLoading = true;
      try {
        await this.addDriverAuto({
          driverId: this.$route.params.driverId,
          autoId: this.selectedAuto.id,
        });
        this.selectedAuto = null;
        this.clearAlertError();
        this.isAutoLoading = false;
      } catch (error) {
        this.isAutoLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
